import {DangerButton} from "./CustomButton";
import EmptyState from "./EmptyState";

export default function ComponentLoader({className="image-aspect-ratio", ...props}) {
  return (
    <div className={`animate-pulse w-full shadow-md ${className}`} {...props}>
      <div className="w-full bg-rand-200 image-aspect-ratio"/>
    </div>

  );
}

export function ComponentError({errorMsg, retry, className="image-aspect-ratio"}) {
  return (
    <div className={`w-full flex justify-evenly flex-col items-center bg-red-100 ${className}`}>
      <div className="px-2 text-sm font-bold leading-none text-center whitespace-pre-wrap text-error-500">{errorMsg}</div>
      <div className="text-center pt-2">
        <DangerButton onClick={retry}>Retry</DangerButton>
      </div>
    </div>
  );
}

export function ComponentNoData({msg, className="image-aspect-ratio"}) {
  return (
    <div className={`w-full empty-box whitespace-pre-wrap flex items-center justify-center bg-secondary-100 px-2 rounded-md ${className}`}>
      <EmptyState message={msg ? msg : 'No Data'} isSmall={true}/>
    </div>
  );
}
